// DigitalSignDialog.tsx — подпись загруженных документов заявки.
//
// Вся механика диалога (состояние формы, запрос одноразового кода, разбор отказов, правило
// закрытия) живёт в общем EsignDialog. Здесь остаётся только специфика сценария: какой эндпоинт
// вызывается и что делать после успеха.
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import MainStore from "./../MainStore";
import EsignDialog, { EsignCredentials } from "./EsignDialog";
import { signFiles } from "api/FileSign";
import i18n from "i18next";

const DigitalSignDialog = observer(() => {
  const { t } = useTranslation();

  return (
    <EsignDialog
      open={MainStore.digitalSign.open}
      id="DigitalSignDialog"
      title={t("label:digitalSign.enterYourInn")}
      // ИНН залогиненного пользователя: подставляется при каждом открытии.
      defaultPin={MainStore.currentUserPin || ""}
      // Прежнее поведение сохранено: успехом считается 2xx С телом ответа.
      isSigned={(response) =>
        (response?.status === 200 || response?.status === 201) && response?.data !== null
      }
      successMessage={t("label:digitalSign.successfullySigned")}
      sign={(c: EsignCredentials) =>
        signFiles(
          MainStore.digitalSign.fileIds,
          MainStore.digitalSign.applicationId,
          c.pin,
          c.code,
          c.pinOrganization,
          // Автопосылка (финальный шаг степпера) + язык шаблона: выбор языка в кабинете,
          // не локаль браузера (тот же принцип, что у WithdrawApplicationDialog).
          MainStore.digitalSign.submitAfterSign,
          i18n.language.split("-")[0]
        )
      }
      // Второй аргумент — тело ответа ({ autoSubmitted, submitErrorCode, submitErrorMessage }):
      // финальному шагу степпера нужно знать, ушла ли заявка тем же запросом. Прочие
      // потребители onCloseYes лишний аргумент игнорируют.
      onSigned={(response, pin) => MainStore.digitalSign.onCloseYes(pin, response?.data)}
      onClose={() => MainStore.digitalSign.onCloseNo()}
    />
  );
});

export default DigitalSignDialog;
